import { Injectable } from '@angular/core';
import { fromEvent, merge, Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConnectionCheck {
  // Emits true if online, false if offline
  public isOnline$: Observable<boolean>;

  constructor() {
    this.isOnline$ = merge(
      // Initial browser state
      new Observable((observer: Observer<boolean>) => {
        observer.next(navigator.onLine);
        observer.complete();
      }),
      // Live window events
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false)),
    );
  }
}
